import { isDefined } from '@automator/utilities';

/**
 * Checks whether the browser supports regex lookbehind.
 * We're using this approach as a temporary solution until Safari supports regex lookbehind
 *
 * @param {Function} func The function to check
 * @param {Number} interval The interval to check
 * @return {Boolean} True if the browser supports it
 */
const supportsRegExLookbehind = ( func, interval ) => {
	// Check if we already checked this before
	if ( isDefined( UncannyAutomatorBackend.debugging.supportsRegExLookbehind ) ) {
		return UncannyAutomatorBackend.debugging.supportsRegExLookbehind;
	}

	// Create variable to save the result
	let response;

	try {
		response = (
			'hibyehihi'
				.replace( new RegExp( "(?<=hi)hi", "g" ), "hello" )
				.replace( new RegExp( "hi(?!bye)", "g" ), "hey" ) === "hibyeheyhello"
		);
	} catch ( e ) {
		response = false;
	}

	// Save it
	UncannyAutomatorBackend.debugging.supportsRegExLookbehind = response;

	return response;
};

export default supportsRegExLookbehind;